exports.get_query_arg = function (purl, key) {
  //console.log(purl, key)
  //console.info(purl);
  if (purl.indexOf(key + '=') > -1) {
    //faconsole.log('testtt');
    var regexS = "[?&]" + key + "(.+?)(?=&|$)";
    var regex = new RegExp(regexS);
    var regtest = regex.exec(purl);


    //console.info(regex, regtest);
    if (regtest != null) {
      //var splitterS = regtest;


      if (regtest[1]) {
        var aux = regtest[1].replace(/=/g, '');
        return aux;
      } else {
        return '';
      }


    }
    //$('.zoombox').eq
  }
}


exports.sanitize_to_youtube_id = function (arg) {

  if (String(arg).indexOf('youtube.com/watch')) {

    var dataSrc = arg;
    var auxa = String(dataSrc).split('youtube.com/watch?v=');
//                            console.info(auxa);

    console.info('auxa - ', auxa);
    if (auxa[1]) {

      dataSrc = auxa[1];
      if (auxa[1].indexOf('&') > -1) {
        var auxb = String(auxa[1]).split('&');
        console.info('auxb - ', auxb);
        dataSrc = auxb[0];
      }


      return dataSrc;
    }
  }

  return arg;
}